/**
 * Utility function to wrap a promise with a timeout
 * @param promise The promise to wrap with a timeout
 * @param timeoutMs The timeout in milliseconds
 * @param errorMessage The error message to throw if the promise times out
 * @returns The result of the promise
 */
export async function promiseWithTimeout<T>(
  promise: Promise<T>,
  timeoutMs: number,
  errorMessage: string,
): Promise<T> {
  let timeoutId: ReturnType<typeof setTimeout>;
  const timeoutPromise = new Promise<never>((_, reject) => {
    timeoutId = setTimeout(() => reject(new Error(errorMessage)), timeoutMs);
  });

  return Promise.race([promise, timeoutPromise]).finally(() => {
    clearTimeout(timeoutId);
  });
}
